/* ============================================================
   เมนูของ AK-HOME — type: "group" คือหัวกลุ่มงาน
   สิทธิ์เข้าเมนูคุมจากหน้า "สิทธิ์การเข้าถึง" (constant/menu.js + api/common/menu.php)
============================================================ */
import { IdcardOutlined, TeamOutlined } from "@ant-design/icons";
import { FaTag } from "react-icons/fa";
import { BsHouseDoor, BsHouses } from "react-icons/bs";
import { MdOutlineChecklist, MdOutlineCategory, MdOutlineViewList, MdOutlineChangeCircle } from "react-icons/md";
import { RiContactsBook2Line } from "react-icons/ri";
import { GiBrickWall } from "react-icons/gi";

let _nav = [
  { title: "Support", type: "group" },
  {
    title: "โปรเจ็กต์บ้าน",
    icon: <BsHouseDoor className="nav-ico" />,
    to: "/support/project",
  },
  {
    title: "ใบเลือกวัสดุ",
    icon: <MdOutlineChecklist className="nav-ico" />,
    to: "/support/selection",
  },
  {
    title: "RC ลูกค้า",
    icon: <MdOutlineChangeCircle className="nav-ico" />,
    to: "/support/rc",
  },
  {
    title: "ข้อมูลลูกค้า",
    icon: <RiContactsBook2Line className="nav-ico" />,
    to: "/support/customer",
  },

  { title: "Master", type: "group" },
  {
    title: "แบบบ้าน",
    icon: <BsHouses className="nav-ico" />,
    to: "/master/house-model",
  },
  {
    title: "วัสดุ",
    icon: <GiBrickWall className="nav-ico" />,
    to: "/master/material",
  },
  {
    title: "หมวดวัสดุ",
    icon: <MdOutlineCategory className="nav-ico" />,
    to: "/master/material-category",
  },
  {
    title: "พนักงาน",
    icon: <IdcardOutlined className="nav-ico" />,
    to: "/master/employee",
  },
  {
    title: "Template เลือกวัสดุ",
    icon: <MdOutlineViewList className="nav-ico" />,
    to: "/master/template",
  },

  { title: "Admin", type: "group" },
  {
    title: "ผู้ใช้งาน",
    icon: <TeamOutlined className="nav-ico" />,
    to: "/user",
  },
  {
    title: "สิทธิ์การเข้าถึง",
    icon: <FaTag className="nav-ico" />,
    to: "/permission",
  },
];

export default _nav;
